import { create } from 'zustand'
import { getTokenCookie, setTokenCookie, removeTokenCookie } from "@/utils/auth.cookies"


interface AuthState {
  token: string | null
  isAuthenticated: boolean
  setToken: (token: string) => void
  removeToken: () => void
}

export const StoreAuth = create<AuthState>((set) => {
  const token = getTokenCookie()

  return {
    token: token ?? null,
    isAuthenticated: !!token,

    setToken: (token: string) => {
      setTokenCookie(token)
      set({
        token,
        isAuthenticated: true
      })
    },

    removeToken: () => {
      removeTokenCookie()
      set({
        token: null,
        isAuthenticated: false
      })
    },
  }
})